/**
 * @generated SignedSource<<5a2a1efe62655cdf82d3fb217ba1323f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettingsSaveMutation$variables = {
  alertOnSlow: boolean;
  cutOffOK: boolean;
  cutoff?: number | null;
  name: string;
  ujID: number;
};
export type selfServiceSettingsSaveMutation$data = {
  readonly setSelfServiceUJSettings: {
    readonly userJourney: {
      readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment">;
    } | null;
  } | null;
};
export type selfServiceSettingsSaveMutation = {
  response: selfServiceSettingsSaveMutation$data;
  variables: selfServiceSettingsSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "alertOnSlow"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cutOffOK"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cutoff"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ujID"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "alertOnSlow",
        "variableName": "alertOnSlow"
      },
      {
        "kind": "Variable",
        "name": "cutOffOK",
        "variableName": "cutOffOK"
      },
      {
        "kind": "Variable",
        "name": "cutoff",
        "variableName": "cutoff"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "ujID"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "kind": "ObjectValue",
    "name": "ujData"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServiceSettingsSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SelfServiceUJSettingsMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "selfServiceSettings_mainSettingsFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "selfServiceSettingsSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SelfServiceUJSettingsMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cutoff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cutOffOK",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertOnSlow",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "50419df020fb4ede39ce98c08004860a",
    "id": null,
    "metadata": {},
    "name": "selfServiceSettingsSaveMutation",
    "operationKind": "mutation",
    "text": "mutation selfServiceSettingsSaveMutation(\n  $ujID: Int!\n  $name: String!\n  $cutoff: Int\n  $cutOffOK: Boolean!\n  $alertOnSlow: Boolean!\n) {\n  setSelfServiceUJSettings(ujData: {id: $ujID, name: $name, cutoff: $cutoff, cutOffOK: $cutOffOK, alertOnSlow: $alertOnSlow}) {\n    userJourney {\n      ...selfServiceSettings_mainSettingsFragment\n      id\n    }\n  }\n}\n\nfragment selfServiceSettings_mainSettingsFragment on UserJourney {\n  id\n  name\n  cutoff\n  cutOffOK\n  alertOnSlow\n}\n"
  }
};
})();

(node as any).hash = "af518f2b9e96db8ee62969b53a2cd772";

export default node;
